export default __webpack_public_path__ + "static/media/info_mine.min.65407c38.png";